<br />
<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color">
            <h1>TODOS LOS SEGUIMIENTOS</h1>
        </div>
        <br />
        <form [formGroup]="filterForm" class="filters-container">
            <div class="line">
                <div class="column-md-3 column-lg-3 column-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Fecha de seguimiento</mat-label>
                        <input
                            matInput
                            [matDatepicker]="picker"
                            placeholder="Fecha de seguimiento"
                            formControlName="date"
                            required
                            readonly
                        />
                        <mat-hint> MM/DD/AAAA </mat-hint>
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                        <mat-error
                            class="for-text text-danger"
                            *ngIf="filterForm.get('date')?.hasError('required')"
                        >
                            Campo obligatorioo
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <br />
        <div></div>
        <br />
        <section class="table-container mat-elevation-z1" tabindex="0">
            <div>
                <table
                    mat-table
                    [dataSource]="
                        (asyncAccompaniment | async)?.results ?? []
                            | paginate
                                : {
                                      id: 'server',
                                      itemsPerPage: limit,
                                      currentPage: page,
                                      totalItems: total,
                                  }
                    "
                >
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let accompaniment">
                            <div class="action-buttons">
                                <a
                                    class="icon-button"
                                    (click)="editAccompaniment(accompaniment)"
                                >
                                    <mat-icon>edit</mat-icon>
                                </a>
                                <a
                                    class="icon-button"
                                    appOnlysuperuser="/accompaniments"
                                    (click)="
                                        deleteAccompaniment(accompaniment.id)
                                    "
                                >
                                    <mat-icon>delete</mat-icon>
                                </a>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="date">
                        <th mat-header-cell *matHeaderCellDef>Fecha</th>
                        <td mat-cell *matCellDef="let accompaniment">
                            {{ accompaniment.date | date }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef>Descripción</th>
                        <td mat-cell *matCellDef="let accompaniment">
                            {{ accompaniment.description }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef>Dirección</th>
                        <td mat-cell *matCellDef="let accompaniment">
                            {{ accompaniment.address }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="location">
                        <th mat-header-cell *matHeaderCellDef>Ubicación</th>
                        <td mat-cell *matCellDef="let accompaniment">
                            {{ accompaniment.location.city }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="file">
                        <th mat-header-cell *matHeaderCellDef>Archivo</th>
                        <td mat-cell *matCellDef="let accompaniment">
                            <ng-container
                                *ngIf="hasFile(accompaniment); else noFile"
                            >
                                <a
                                    href
                                    (click)="
                                        openFile(accompaniment);
                                        $event.preventDefault()
                                    "
                                    style="
                                        cursor: pointer;
                                        text-decoration: underline;
                                    "
                                >
                                    {{ accompaniment.fileAttach.fileName }}
                                </a>
                            </ng-container>
                            <ng-template #noFile
                                ><span>No disponible</span></ng-template
                            >
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: showColumns"
                        class="highlight-row"
                    ></tr>
                </table>
            </div>
        </section>

        <pagination-controls
            (pageChange)="fetchAccompaniment($event)"
            previousLabel="Anterior"
            nextLabel="Siguiente"
            id="server"
        ></pagination-controls>
    </div>
</div>
